// TODO refactor, it doesn't make sense
const BatLandingPosition = {
    'CenterField': { key: 'CF', name: 'Center Field'},
    'CenterInfield': { key: 'CI',name: 'Center Infield'},
    'LeftField': { key: 'LF',name: 'Left Field'},
    'LeftInfield': { key: 'LI',name: 'Left Infield'},
    'RightField': { key: 'RF',name: 'Right Field'},
    'RightInfield': { key: 'RI',name: 'Right Infield'},
    'CenterHomeRun': { key: 'CH',name: 'Center Home Run'},
    'LeftHomeRun': { key: 'LH',name: 'Left Home Run'},
    'RightHomeRun': { key: 'RH',name: 'Right Home Run'},
    'Undefined': { key: 'UZ',name: 'Undefined Zone'}
};

export default BatLandingPosition;